var pic1 = require('../../assets/images/buildings/pic1.jpg');
var pic2 = require('../../assets/images/buildings/pic15.jpg');
var pic3 = require('../../assets/images/buildings/pic3.jpg');
var pic4 = require('../../assets/images/buildings/pic4.jpg');
var pic5 = require('../../assets/images/buildings/pic6.jpg');
var pic6 = require('../../assets/images/buildings/pic9.jpg');
var pic7 = require('../../assets/images/buildings/pic16.jpg');

const DataElementsEventSlider = [
{    
	id: 1,
    image: pic1,	
    title: "Our Building",       
    description: "We take pride in providing excellent infrastructure, Eco-friendly plantations, and a super safe school environment.",
	link: "facility"
  },
  {
    id: 2,
    image: pic2,	
    title: "Smart Class Rooms",    
    description: "A Smart Classroom is an educational setting with advanced technologies supporting dynamic teaching and learning.",
	link: "classrooms"
  },
  {
    id: 3,
    image: pic3,	
    title: "Sports",    
    description: "School sports are physical activities that students can do at school as part of their curriculum or extracurricular program.",
	link: "sports"
  },
  {
    id: 4,
    image: pic4,	
    title: "School Library",    
    description: "The Library is supposed to be the nerve centre of any educational Institution.The School maintains a well equipped library for the use of student and teachers under a trained Librarian.",
	link: "library"
  },
  {
    id: 5,
    image: pic5,	
    title: "School Labs",    
    description: "The Science and Technology block allows the School to provide courses relevant to the needs of the pupils.",
	link: "labs"
  },
  {
    id: 6,
    image: pic6,	
    title: "Transport Facility",    
    description: "School has its own buses with well facilities. All Buses are well maintained.",
	link: "transport"
  },
  {
    id: 7,
    image: pic7,	
    title: "Music & Dance",    
    description: "The students are trained to be perform their talent in both western and classical as well as folk music.",
	link: "music&dance"
  },
  {
    id: 8,
    image: pic6,	
    title: "Art & Craft",    
    description: "In pre-pottery section, the student are being taught like different forms of art and craft with clay gains colour shapes etc.",
	link: "art&craft"
  },
  {
    id: 9,
    image: pic6,	
    title: "Tour and excursions",    
    description: "The practical knowledge also provides them to do work and corporation.",
	link: "tour"
  }  
];
export default DataElementsEventSlider;